import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const CloseIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon {...props} viewBox="0 0 12.013 12.013">
      <g id="Group_1547" data-name="Group 1547" transform="translate(-7.698 -82.404) rotate(45)">
        <g id="Group_87" data-name="Group 87" transform="translate(65.183 46.307)">
          <g id="Group_83" data-name="Group 83" transform="translate(7 0) rotate(45)">
            <line
              id="Line_1"
              data-name="Line 1"
              x2="9.185"
              y2="9.185"
              transform="translate(0.033 0)"
              fill="none"
              stroke={props.color || theme.palette.gray.light}
              strokeLinecap="round"
              strokeWidth="2"
            />
            <line
              id="Line_2"
              data-name="Line 2"
              y1="9.185"
              x2="9.185"
              transform="translate(0.033 0)"
              fill="none"
              stroke={props.color || theme.palette.gray.light}
              strokeLinecap="round"
              strokeWidth="2"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};
